import getConfig from 'next/config';
import { baseFetcher } from '../base.fetchers';

const { publicRuntimeConfig } = getConfig();
// Swagger: https://phoenix-pm-ums.parcelperform.com/docs
export const BASE_URL = `${publicRuntimeConfig.pmUmsUrl}/api`;

// Fetch UMS API with authentication flow by passing hasAuthFlow = true to baseFetcher
export const umsFetcher = baseFetcher(BASE_URL, true);
